import { Pipe, PipeTransform } from '@angular/core';
import {JsLineDec, SteelListValidity} from '../json-interface';
import { CLineDec, GradeManager } from './info-decorticage';
import { CProduct } from './info-product';
import {MatDialog} from '@angular/material/dialog';
import {CUtilit, ModalUtilit} from '../utilit';
import {TranslateService} from '@ngx-translate/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import {SteelListStatus} from '../const';

export type TypeAnalysisLine = 'SteelLine'|'ProductLine'|'RepartLine'|'WMeshLine'|undefined;

export class UtilitAnalysis {

  public static getTypeJsLineDec(jsLineDec: JsLineDec): TypeAnalysisLine {
      if (jsLineDec.SteelLine)
          return 'SteelLine';
      else if (jsLineDec.ProductLine)
          return 'ProductLine';
      else if (jsLineDec.RepartLine)
          return 'RepartLine';
      else if (jsLineDec.WMeshLine)
          return 'WMeshLine';
      return undefined;
  }

  /**
   * Insert les ligne dec en premier puis les ligne de produit
   * @param arrayAnalysisLine Liste provenant du tableau de décorticage
   * @param arrayProductLine Liste provenant du tableau de produit
   * @returns Tableau de jsLineDec, pour transfert vers le serveur
   */
  public static convertToJsLineDecProduct(arrayAnalysisLine: CLineDec[],
                                          arrayProductLine: CProduct[]): JsLineDec[] {
      const arrayJsLineDec: JsLineDec[] = [];
      // On ajoute les ligne "standart"
      arrayAnalysisLine.forEach(analysisLine => arrayJsLineDec.push(analysisLine.toJsLineDec()));
      // On ajoute les produit a la fin du tablau
      arrayProductLine.forEach(productLine => arrayJsLineDec.push(productLine.toJsLineDec(arrayJsLineDec.length + 1)));

      return arrayJsLineDec;
  }

  public static createClassFromJsLineDec(jsLineDec: JsLineDec): CLineDec|CProduct {
      let result: CLineDec|CProduct;
      if (jsLineDec.ProductLine) {
          result = new CProduct();
          result.loadFromJsLineDec(jsLineDec);
      } else {
          result = new CLineDec();
          result.loadFromjsLineDec(jsLineDec);
      }
      return result;
  }

  public static async modalConfirmSendOrder(matDialog: MatDialog): Promise<boolean> {
    const message = 'Une commande indiquée comme validée n\'est plus modifiable par la suite, voulez-vous continuer ?';
    const title = 'Avertissement';
    return await ModalUtilit.yesNoCancel(matDialog, message, title);
  }

  /**
   * Controle la validité de l'envoi de la liste d'acier <br>
   * Retourne true si pas d'erreur sinon affiche un snackbar avec la raison de l'erreur
   */
  public static async checkResultSteelListSend(resultSteelListSend: SteelListValidity,
                                               matSnackBar: MatSnackBar,
                                               ts: TranslateService,
                                               displayBtnOpenOrder: boolean = false,
                                               onOpenOrderClick: (() => void) | undefined = undefined) {
    // Recup des message traduit
    const sbBtnMessageOpenorder = displayBtnOpenOrder ? await ts.get('Ouvrir la commande').toPromise() : await ts.get('Fermer').toPromise();
    const startMessage = await ts.get('Impossible d\'envoyer la commande').toPromise();
    let contentMessage = '';
    if (resultSteelListSend.NoCustomerRef)
      contentMessage = await ts.get('Référence client obligatoire').toPromise();
    else if (resultSteelListSend.NoDeliveryDate)
      contentMessage = await ts.get('Date de livraison obligatoire').toPromise();
    else if (resultSteelListSend.NoUniqueCustomerRef)
      contentMessage = await ts.get('Référence client déjà utilisée').toPromise();
    else if (resultSteelListSend.NoContact)
      contentMessage = await ts.get('Contact obligatoire').toPromise();
    // Création de la snackbar
    const onCloseEvent = await CUtilit.showSnackBar(matSnackBar, undefined, `${startMessage}: ${contentMessage}`,
      sbBtnMessageOpenorder, 10, true);
    // Ajout de l'event sur le clique du bouton
    if (onOpenOrderClick)
      onCloseEvent.subscribe(() => onOpenOrderClick());
  }

  public static getDescriptionStatusSteelList(steelListStatus: number): string {
    // Traduit dans le html
    switch (steelListStatus) {
      case SteelListStatus.stWaiting:
        return 'La commande est en attente d\'envoi';
      case SteelListStatus.stValidate:
        return 'L\'usine a validé la commande';
      case SteelListStatus.stDeny:
        return 'La commande a été annulée par l\'usine';
      case SteelListStatus.stCancel:
        return 'La commande a été annulée par vous';
      case SteelListStatus.stSend:
        return 'La commande est envoyée et attend la validation de l\'usine';
    }
    return '';
  }
}

/**
 * A pipe dans le html pour séparer en un tableau le diametre et la nuance
 * [0] = diametre
 * [1] = nuance
 */
@Pipe({name: 'splitDiamGrade'})
export class SpliteDiamGradePipe implements PipeTransform {
  transform(value: string, ...args: any[]): string[] {
    const diamGrade = GradeManager.separateDiamGrade(value);
    return [
        diamGrade.diam?.toString(),
        diamGrade.grade
    ];
  }
}
